<template>
	<vs-popup
		:active.sync="isActive"
		title="Modifier l'URL LinkedIn"
		@close="onClose"
	>
		<div class="flex flex-col" style="gap: 12px">
			<vs-input
				class="w-full"
				label="URL LinkedIn"
				placeholder="https://www.linkedin.com/company/..."
				v-model="linkedinUrl"
				@input="urlError = ''"
			/>
			<span v-if="urlError" style="color: #ea5455; font-size: 0.85rem">
				{{ urlError }}
			</span>
			<div class="flex justify-end mt-2">
				<vs-button
					color="primary"
					type="filled"
					:disabled="isLoading"
					@click="execute"
				>
					{{ isLoading ? "En cours..." : "Exécuter" }}
				</vs-button>
			</div>
		</div>
	</vs-popup>
</template>

<script>
import ProspectSearch from "@/entities/ProspectSearch";

export default {
	name: "EditLinkedinUrlPopup",
	props: {
		popupActive: {
			type: Boolean,
			default: true,
		},
		prospectId: {
			type: Number,
			required: true,
		},
		currentUrl: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			isActive: this.$props.popupActive,
			// Don't prefill the literal "loading" placeholder value
			linkedinUrl:
				this.$props.currentUrl && this.$props.currentUrl !== "loading" ?
					this.$props.currentUrl :
					"",
			urlError: "",
			isLoading: false,
		};
	},
	methods: {
		/**
		 * Basic URL validation: must be a well-formed http(s) URL.
		 * @param {String} url
		 * @returns {Boolean}
		 */
		isValidUrl(url) {
			if(!url || !url.trim()) return false;
			try{
				const parsed = new URL(url.trim());
				return parsed.protocol === "http:" || parsed.protocol === "https:";
			}
			catch(e) {
				return false;
			}
		},
		async execute() {
			const url = this.linkedinUrl.trim();

			if(!this.isValidUrl(url)) {
				this.urlError =
					"Veuillez saisir une URL valide (ex: https://www.linkedin.com/...)";
				return;
			}

			this.isLoading = true;
			try{
				await ProspectSearch.updateLinkedinUrl(this.$props.prospectId, url);
				this.$vs.notify({
					title: "Succès",
					text: "L'URL LinkedIn a été mise à jour",
					color: "success",
				});
				this.$emit("updated", url);
				this.isActive = false;
			}
			catch(e) {
				console.log("Error: updateLinkedinUrl", e);
				this.$vs.notify({
					title: "Erreur",
					text: "Une erreur est survenue lors de la mise à jour de l'URL LinkedIn",
					color: "danger",
				});
			}
			finally {
				this.isLoading = false;
			}
		},
		onClose() {
			this.isActive = false;
			this.$emit("close");
		},
	},
};
</script>
